"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getViewportForBounds = exports.getViewportForFeature = exports.getFeatureGeometryType = exports.defaultMapStyle = void 0;

var _immutable = require("immutable");

var _viewportMercatorProject = _interopRequireDefault(require("viewport-mercator-project"));

var _bbox = _interopRequireDefault(require("@turf/bbox"));

var _style = _interopRequireDefault(require("./style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/** Default mapboxgl style */
var defaultMapStyle = (0, _immutable.fromJS)(_style["default"]);
/**
 * Returns the geometry type for a feature
 * @param {*} feature
 * @returns {string}
 */

exports.defaultMapStyle = defaultMapStyle;

var getFeatureGeometryType = function getFeatureGeometryType(feature) {
  if (!feature.geometry || !feature.geometry.type) return null;
  return feature.geometry.type;
};
/**
 * Returns updated viewport that centers the viewport on a given feature
 * @param {*} feature
 * @param {*} initialViewport
 * @returns {object} { latitude, longitude, zoom }
 */


exports.getFeatureGeometryType = getFeatureGeometryType;

var getViewportForFeature = function getViewportForFeature(feature, initialViewport) {
  var type = getFeatureGeometryType(feature);
  if (!type) return {};

  if (type === "Point") {
    var _feature$geometry$coo = _slicedToArray(feature.geometry.coordinates, 2),
        longitude = _feature$geometry$coo[0],
        latitude = _feature$geometry$coo[1];

    return {
      latitude: latitude,
      longitude: longitude,
      zoom: 14
    };
  }

  var featureBbox = (0, _bbox["default"])(feature);
  var bounds = [[featureBbox[0], featureBbox[1]], [featureBbox[2], featureBbox[3]]];
  return getViewportForBounds(bounds, initialViewport);
};
/**
 * Returns updated viewport state given bounds
 * @param {array} bounds [[minX, minY], [maxX, maxY]]
 * @param {*} baseViewport a base viewport to extent (default: `{}`)
 * @param {*} options object with options ({padding})
 * @returns
 */


exports.getViewportForFeature = getViewportForFeature;

var getViewportForBounds = function getViewportForBounds(bounds) {
  var baseViewport = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var width = baseViewport.width;
  var height = baseViewport.height;
  var padding = options.padding || 20;
  var vp = new _viewportMercatorProject["default"]({
    width: width,
    height: height
  }).fitBounds(bounds, {
    padding: padding
  });
  return _objectSpread(_objectSpread({}, baseViewport), {}, {
    latitude: vp.latitude,
    longitude: vp.longitude,
    zoom: vp.zoom
  });
};

exports.getViewportForBounds = getViewportForBounds;